export const REQUEST_AVAILABLE_ENTERTAINMENTS = 'REQUEST_AVAILABLE_ENTERTAINMENTS';
export const RECEIVE_AVAILABLE_ENTERTAINMENTS = 'RECEIVE_AVAILABLE_ENTERTAINMENTS';
export const SET_AVAILABLE_ENTERTAINMENTS_FAILURE = 'SET_AVAILABLE_ENTERTAINMENTS_FAILURE';
export const CLEAR_AVAILABLE_ENTERTAINMENTS_ERROR_MESSAGE = 'CLEAR_AVAILABLE_ENTERTAINMENTS_ERROR_MESSAGE';
